'use client'

import GoogleTagManager from '@/components/GoogleTagManager/GoogleTagManager'
import Loading from '@/components/Loading/Loading'
import styles from '@/styles/main.scss'

import Script from 'next/script'

import Hubspot from '@/components/Hubspot/HubspotChat'

export default function RootLayout({ children }) {
    return (
        <>
            <title>Taxd - Login</title>
            <Script
                src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
                strategy="afterInteractive"
            />
            <link rel="icon" href="/favicon.png" type="image/png" sizes="16x16" />
            <Hubspot />
            <GoogleTagManager />
            {children}
        </>
    )
}
